// The confidence idiom from the design's foundation gallery: high/med are
// filled dots of different hues, low is the SAME hue as med but a hollow
// ring (the shape carries the "not applied automatically" meaning, never the
// colour alone), and user-set is a solid ink SQUARE with no dot at all.
import { StatusDot } from './StatusDot';

export type ConfidenceLevel = 'high' | 'med' | 'low' | 'user';

const LEVEL_LABEL: Record<ConfidenceLevel, string> = {
  high: 'High confidence',
  med: 'Medium confidence',
  low: 'Likely related',
  user: 'User-set',
};

export function ConfidenceDot({
  level,
  showLabel = false,
  className,
}: {
  level: ConfidenceLevel;
  showLabel?: boolean;
  className?: string;
}) {
  const tone = level === 'user' ? 'neutral' : level === 'low' || level === 'med' ? 'warn' : 'ok';
  const shape = level === 'user' ? 'square' : level === 'low' ? 'hollow' : 'filled';

  return (
    <span data-confidence-level={level}>
      <StatusDot tone={tone} shape={shape} label={LEVEL_LABEL[level]} showLabel={showLabel} className={className} />
    </span>
  );
}

export default ConfidenceDot;
